import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-2.png';
import Footer from '../../components/Layout/Footer';
import {
  consumeBuyerMagicLink,
  getBuyerToken,
  setBuyerSession,
} from '../../services/buyerTicketsApi';
import './MesTickets.css';

/** Évite un double POST (React Strict Mode / double clic). */
const consumeInflight = new Map();

async function consumeOnce(token) {
  if (consumeInflight.has(token)) {
    return consumeInflight.get(token);
  }
  const promise = consumeBuyerMagicLink(token).finally(() => {
    // garder un court instant pour les doubles appels simultanés
    setTimeout(() => consumeInflight.delete(token), 2000);
  });
  consumeInflight.set(token, promise);
  return promise;
}

const MesTicketsAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = String(searchParams.get('token') || '').trim();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (getBuyerToken()) {
      navigate('/mes-tickets/liste', { replace: true });
    }
  }, [navigate]);

  const confirmLogin = useCallback(async () => {
    if (!token) {
      setError('Lien invalide : jeton manquant.');
      return;
    }
    setError('');
    setBusy(true);
    try {
      const data = await consumeOnce(token);
      setBuyerSession({
        token: data?.token,
        email: data?.email,
      });
      navigate('/mes-tickets/liste', { replace: true });
    } catch (err) {
      setError(
        err?.message ||
          'Ce lien est invalide, expiré ou a déjà été utilisé. Demandez-en un nouveau.',
      );
      setBusy(false);
    }
  }, [token, navigate]);

  return (
    <React.Fragment>
      <Header
        navImg={navImg1}
        parentMenu="MesTickets"
        activeMenu="/mes-tickets"
      />
      <div className="mes-tickets-page mes-tickets-page--auth">
        <div className="container">
          <div className="mes-tickets-page__layout">
            <section className="mt-card">
              <div className="mt-profile mt-profile--in-card">
                <div className="mt-profile__avatar" aria-hidden="true">
                  <i className="fas fa-key" />
                </div>
                <div className="mt-profile__body">
                  <p className="mt-profile__eyebrow">Connexion sécurisée</p>
                  <h1 className="mt-profile__name">Confirmer l’accès</h1>
                  <p className="mt-profile__email">
                    Cliquez sur le bouton pour accéder à vos billets.
                  </p>
                </div>
              </div>

              {!token ? (
                <>
                  <div className="mt-alert mt-alert--error" role="alert">
                    Lien invalide : jeton manquant.
                  </div>
                  <Link to="/mes-tickets" className="thm-btn mt-btn mt-btn--full">
                    Demander un nouveau lien
                  </Link>
                </>
              ) : (
                <>
                  {error ? (
                    <div className="mt-alert mt-alert--error" role="alert">
                      {error}
                    </div>
                  ) : null}
                  <button
                    type="button"
                    className="thm-btn mt-btn mt-btn--full"
                    onClick={confirmLogin}
                    disabled={busy}
                  >
                    {busy ? 'Connexion…' : 'Accéder à mes billets'}
                  </button>
                  {error ? (
                    <p style={{ marginTop: 16, textAlign: 'center' }}>
                      <Link to="/mes-tickets" style={{ color: '#f9a8d4' }}>
                        Demander un nouveau lien
                      </Link>
                    </p>
                  ) : null}
                </>
              )}
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default MesTicketsAuth;
